import ApiService from "../../services/api.service";

const state = {
    shipping_charge : '0.00',
    one_tyre_shipping_charge : null,
    two_tyre_shipping_charge : null,
    three_tyre_shipping_charge : null,
    four_tyre_shipping_charge : null,
}

const getters = {
    shipping_charge : state => state.shipping_charge,
    one_tyre_shipping_charge : state => state.one_tyre_shipping_charge,
    two_tyre_shipping_charge : state => state.two_tyre_shipping_charge,
    three_tyre_shipping_charge : state => state.three_tyre_shipping_charge,
    four_tyre_shipping_charge : state => state.four_tyre_shipping_charge
}

const mutations = {
    setShippingCharge(state, value) {
        state.shipping_charge = value;
    },
    setOneTyreShippingCharge(state, value) {
        state.one_tyre_shipping_charge = value;
    },
    setTwoTyreShippingCharge(state, value) {
        state.two_tyre_shipping_charge = value;
    },
    setThreeTyreShippingCharge(state, value) {
        state.three_tyre_shipping_charge = value;
    },
    setFourTyreShippingCharge(state, value) {
        state.four_tyre_shipping_charge = value;
    }
}

const actions = {
    async getShippingCharge({commit}, data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/get-shipping-charge', {quantity : data})
                .then(response => {
                    commit('setShippingCharge', response.data.shipping_charge);
                    commit('setOneTyreShippingCharge', response.data.one_tyre_shipping_charge);
                    commit('setTwoTyreShippingCharge', response.data.two_tyre_shipping_charge);
                    commit('setThreeTyreShippingCharge', response.data.three_tyre_shipping_charge);
                    commit('setFourTyreShippingCharge', response.data.four_tyre_shipping_charge);
                    resolve()
                }).catch((e) => {
                console.log(e.message);
                reject()
            }).finally(() => {

            })
        });
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}